import { render, staticRenderFns } from "./OnProgress.vue?vue&type=template&id=31df7590"
import script from "./OnProgress.vue?vue&type=script&lang=js"
export * from "./OnProgress.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports